import { t } from '@lingui/core/macro';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CalendarDefaultsForm } from './-components/calendar-defaults-form';
import {
  SettingsSection,
  SettingsSectionSkeleton,
} from './-components/settings-section';
import { calendarDefaultsQueryOptions } from './-utils/calendar-defaults-query';
import { SETTINGS_HELP } from './-utils/help-articles';

export const Route = createFileRoute(
  '/researchers/_authenticated/settings/calendar-defaults',
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      calendarDefaultsQueryOptions(context.user.id),
    ),
  pendingComponent: SettingsSectionSkeleton,
  component: CalendarDefaultsPage,
  head: () => ({ meta: [{ title: t`Calendar defaults` }] }),
});

function CalendarDefaultsPage() {
  const { user } = Route.useRouteContext();
  const { data: defaults } = useSuspenseQuery(
    calendarDefaultsQueryOptions(user.id),
  );

  return (
    <SettingsSection
      helpUrl={SETTINGS_HELP.calendarDefaults}
      title={t`Calendar defaults`}
      description={t`Applied to new calendars you create for projects.`}
    >
      <CalendarDefaultsForm defaults={defaults} userId={user.id} />
    </SettingsSection>
  );
}
